import { createAdminAsyncThunk } from '@/store/thunks/createAdminAsyncThunk';
import { isAPIError } from '@/store/utils/index';

// eslint-disable-next-line @typescript-eslint/no-invalid-void-type -- void
export const confirmPhoneThunk = createAdminAsyncThunk<void, { code: string }>(
  'auth/confirmPhone',
  async(params, { extra: { authService }, rejectWithValue }) => {
    try {
      await authService.confirmPhone(params);
    } catch (error) {
      if (isAPIError(error) && error.fieldErrors !== null) {
        return rejectWithValue({ fieldErrors: error.fieldErrors });
      }
      throw error;
    }
  }
);
